// extracted by mini-css-extract-plugin
export default {"checkIcon":"SetupAccount_checkIcon__ir8VK","subtitle":"SetupAccount_subtitle__qItkb","skeletonLoadingAnimation":"SetupAccount_skeletonLoadingAnimation__Ck4fd"};